export const CHAT_SEARCH_TAGS = ['All', 'Escalated', 'Unread'];
